import React, {useEffect, useState}from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Styles from './styles';
import FormPageHeader from '../../../../../components/shared/FormPageHeader';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { editCustomer, getAllCustomers } from '../../customers/customer.service';
import { Customer } from '../../customers/customer.model';
import { useFormik } from 'formik';
import { GSTTreatment, PlaceOfSupply } from '../../../../../common/common.model';
import validation from './validation';
import { formatDate, showErrorSnackbar, showSnackbar, showSuccessSnackbar } from '../../../../../common/common.service';
import { useSnackbar } from 'notistack';
import ItemList from '../ItemList';
import { Invoice, InvoiceItem, Item } from '../invoice.model';
import { addInvoice, editInvoice, getAllInvoices, getAllItems, getInvoice } from '../invoice.service';
import Loading from '../../../../../components/shared/Loading';
import { getUser, updateUser } from '../../../../login/login.service';
import { User } from '../../../../login/user.model';
import { useConfirm } from 'material-ui-confirm';

const inputProps = {
  disableUnderline:true,
  style:{
    fontSize:'14px'
  }
};

export default function AddInvoice (props: any): JSX.Element {
  const classes = Styles();
  const snackbar = useSnackbar();
  const [editMode, setEditMode] = useState(false);
  let [loading, setLoading]   =   useState(false);
  const [ patch, setPatch ] = useState(false);
  const [customerList, setCustomerList] = useState<Customer[]>([]);
  const [loadingText, setLoadingText] = useState<string>("");

  const [itemList, setItemList] = useState<Item[]>([]);
  
  const [rowListState, setRowList] = useState<InvoiceItem[]>([]);
  const [rowListValid, setRowListValid] = useState<boolean | null>(null); // Keeping `null` as default because to validate whethere it is first time or not
  const confirm = useConfirm()

  let mounted: boolean = true;


  const setCustomers = async () => {
    if(mounted) {
      getAllCustomers((customers: Customer[]) => {
        if(mounted) {
          setCustomerList(customers);
        }
      });
    }
  }

  const setItems = (customer: Customer = new Customer({items: []})) => {
    if(customer.id === '') {
      getAllItems((items: Item[]) => {
        setItemList(items);
      });
    } else {
      getAllItems((itemsFromDb: Item[]) => {
        // This will concatenate items from customer and db, and remove duplicates (itemsFromdb which are already in customer.items)
        let items: Item[] = [...customer.items, ...itemsFromDb].filter((v: any,i: any,a: any)=>a.findIndex((t: any)=>(t.id === v.id))===i);
        setItemList(items);
      });
    }
  }

  // Triggered whenever rowListState is changed!
  useEffect(() => {
    console.log(rowListState);
    if(rowListState.length !== 0) {
      setRowListValid(true);
    } else if(rowListValid === false) {
      setRowListValid(false);
    }
  },[rowListState]);

  const handleSubmit = (values: any) => {
    setLoading(true);
    console.log(rowListValid);
    if(rowListState.length === 0) {
      setLoading(false);
      setRowListValid(false);
      return;
    }
  
    const customer = customerList.find(cus => cus.id === values.customer);
    let subTotal = 0
    let cgst = 0
    let sgst = 0
    rowListState.forEach((row: any) => {
      subTotal += row.amount;
      const gst = ((row.amount * row.tax)/100);
      cgst += (gst/2);
      sgst += (gst/2);
    });
    // Updating localVehicleNo
    const user = new User({
      ...getUser(),
      lastVehicleNo: formik.values.vehicle
    })
    updateUser(user);
  
    subTotal = parseFloat(subTotal.toFixed(2))
    cgst = parseFloat(cgst.toFixed(2))
    sgst = parseFloat(sgst.toFixed(2))
    const total = parseFloat((subTotal + cgst + sgst).toFixed(2));
    const invoice = new Invoice({...values, customer, items: rowListState, subTotal, cgst, sgst, total});
    if(editMode) {
      setEditMode(false);
      // editInvoice(props.match.params.id, invoice).then(data => {
      //   setLoading(false);
      //   showSuccessSnackbar(snackbar, 'Invoice updated successfully!', true)
      //   props.history.push('/dashboard/invoices');
      //   formik.resetForm();
      // }).catch(() => {
      //   setLoading(false);
      //   showErrorSnackbar(snackbar, 'Something went wrong!', true)
      // }); 
      editInvoice(props.match.params.id, invoice, (status: number) => {
        if(status === 5) {
          setLoading(false);
          props.history.push('/dashboard/invoices');
          return;
        }
        if(!loading) {
          setLoading(true);
        }

        if(status === 0) {
          setLoadingText('Saving process 1/4');
        } else if(status === 1) {
          setLoadingText('Saving process 2/4');
        } else if(status === 3) {
          setLoadingText('Saving process 3/4');
        } else if(status === 4) {
          setLoadingText('Saving process 4/4');
        }
      })
    } else {
      addInvoice(invoice).then(data => {
        if(mounted) {
          setLoading(false);
          showSuccessSnackbar(snackbar, 'Invoice saved successfully!', true)
          props.history.push('/dashboard/invoices');
          // formik.resetForm();
          // setRowList([]);
        }
      }).catch(() => {
        setLoading(false);
        showErrorSnackbar(snackbar, 'Something went wrong!', true)
      }); 
    }

    if(customer) {
      customer.items = [...rowListState.map(row => new Item(row).toJson()), ...customer.items].filter((v: any,i: any,a: any)=>a.findIndex((t: any)=>(t.id === v.id))===i).map(item => new Item(item));
      editCustomer(customer.id, customer).then(_ => console.log(_)).catch(err => console.log(err));
    }
  }
  
  const formik = useFormik({
    initialValues: {
      customer: 'customerid',
      number: '',
      date: formatDate( new Date().toDateString()),
      billingAddress: '',
      gstin: 	'',
      gstTreatment: 	GSTTreatment.Registered,
      placeOfSupply: 	PlaceOfSupply.TN,
      vehicle: getUser().lastVehicleNo,

    },
    validateOnChange: false,
    validationSchema: validation,
    onSubmit: handleSubmit
  });

  let customers: any[] = [
    <MenuItem key={99999999} value={'customerid'}>Select Customer</MenuItem>
  ];
  if(customerList.length) {
    const mappedCustomers = customerList.map((customer, index) => (
      <MenuItem key={index} value={customer.id}>{ customer.companyName }</MenuItem>
    ));
    customers.push(...mappedCustomers);
  }

  const handleCancel = () => {
    (!editMode) && showSnackbar(snackbar, 'Cancelled!', true, 1000)
    props.history.goBack()
  }

  const patchValues = async () => {
    setPatch(true);
    setLoading(true);
    setEditMode(true);
    // const invoice: Invoice = await getInvoice(props.match.params.id);
    getInvoice(props.match.params.id, (invoice: Invoice) => {
      if(mounted) {
        formik.setValues({
          ...invoice,
          customer: invoice.customer.id,
          date: formatDate(invoice.date),
          vehicle: getUser().lastVehicleNo
        });
        setRowList(invoice.items);
        setLoading(false);
        setPatch(false);
      }
    })
    console.log('patchValues')
  }
  // Component did mount
   useEffect( ()  => {
    setCustomers();
    setItems();
    const customerId = new URLSearchParams(props.location.search).get('customerId')
    if(customerId) {
      formik.setFieldValue('customer', customerId);
    }
    if(props.match.params.id !== 'new') {
      patchValues();
    } else{
      getAllInvoices((invoices: Invoice[])=>{
        formik.setFieldValue('number', (invoices.length+1).toString());
      } )
     
    }

    return () => {
      mounted = false;
    }
  }, []);

  // Triggered when customer value is changed!
  useEffect(() => {
    console.log('Called', mounted)
    if(mounted) {
      console.log(customerList)
      if(customerList.length) {
        const customer = customerList.find(cus => cus.id === formik.values.customer);
        if(customer) {
          formik.setFieldValue('billingAddress', customer.address)
          formik.setFieldValue('gstTreatment', customer.gstTreatment);
          formik.setFieldValue('gstin', customer.gstin);
          setItems(customer);
        }
      }
     
    }
  }, [formik.values.customer, customerList])

  let subTotal = 0
  let cgst = 0
  let sgst = 0
  let tax = 0
  rowListState.forEach((row: any) => {
    subTotal += row.amount;
    tax += ((row.amount * row.tax)/100);
  });
  subTotal = parseFloat(subTotal.toFixed(2))
  cgst = parseFloat((tax/2).toFixed(2))
  sgst = parseFloat((tax/2).toFixed(2))
  const total = parseFloat((subTotal + cgst + sgst).toFixed(2));
  

  return (
    <div className={classes.main}>
      <header className={classes.header}>
        <FormPageHeader title="Add Invoice" update={editMode} saveHandler={formik.handleSubmit} cancelText={editMode ? "Go back": undefined} cancelHandler={handleCancel}/>
      </header>

      <div className={classes.body}>
        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{fontWeight:"bold", color:"#112B42"}}>Company Name { formik.touched.customer && formik.errors.customer ? <span>{formik.errors.customer}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.custname}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              disabled={editMode}
              {...formik.getFieldProps('customer')}
            >
              { customers }
            </TextField>
            <br/>
          </div>
          <div className={classes.labeltext} >
          <div className={classes.column2}>
            <label htmlFor="" className={classes.label}>Vehicle No. { formik.touched.vehicle && formik.errors.vehicle ? <span>{formik.errors.vehicle}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.righttextfield}
              onFocus={(e: any) => e.target.select()}
              // disabled={editMode}
              {...formik.getFieldProps('vehicle')}
            /><br/>
            <br/>
          </div>
        </div>
        </div>

        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Invoice No { formik.touched.number && formik.errors.number ? <span>{formik.errors.number}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.invoiceno}
              onFocus={(e: any) => e.target.select()}
              // disabled={editMode}
              {...formik.getFieldProps('number')}
            /><br/>
          </div>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Invoice Date { formik.touched.date && formik.errors.date ? <span>{formik.errors.date}</span> : null } </label><br/>
            <div className={classes.calendarposition}>
              <TextField
                id="date"
                InputProps={inputProps}
                className={classes.date}
                type="date"
                onFocus={(e: any) => e.target.select()}
              // disabled={editMode}
                {...formik.getFieldProps('date')}
              />
              <br/>
              {/* <img src="/img/calendar1.png" className={classes.calendaricon}/> */}
            </div>
          </div>
          <div className={classes.column2} style={{ color:"#112B42"}}>
            <label htmlFor="" className={classes.label}>GST Treatment { formik.touched.gstTreatment && formik.errors.gstTreatment ? <span>{formik.errors.gstTreatment}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.righttextfield}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              // disabled={editMode}
              { ...formik.getFieldProps('gstTreatment') }
            >
              <MenuItem value={GSTTreatment.Registered}>{GSTTreatment.Registered}</MenuItem>
              <MenuItem value={GSTTreatment.Unregistered}>{GSTTreatment.Unregistered}</MenuItem>
              <MenuItem value={GSTTreatment.None}>{GSTTreatment.None}</MenuItem>
            </TextField>
            <br/>
          </div>
        </div>

        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}  style={{fontWeight:"bold", color:"#112B42"}}>Billing Address { formik.touched.billingAddress && formik.errors.billingAddress ? <span>{formik.errors.billingAddress}</span> : null } </label><br/>
            <div className={classes.editaddress}>
            <TextField
              multiline
              rows={6}
              InputProps={inputProps}
              className={classes.billaddress}
              onFocus={(e: any) => e.target.select()}
              // disabled={editMode}
              { ...formik.getFieldProps('billingAddress') }
            />
            <br/>
            
            {/* <Button size="small" className={classes.editicon}>
            <img src="/img/grouppencil.png" alt="pencil icon" style={{position:"absolute", right:"40px", width:"15px"}}/>
            <img src="/img/grouppencilheadline.png" alt="pencil icon" style={{position:"absolute",top:"10px", right:"42px", width:"6px"}}/>
            <img src="/img/grouppencilunderline.png" alt="pencil icon" style={{position:"absolute", top:"24px", right:"38px", width:"17px"}}/>
            
            Edit
            </Button> */}
            
            </div>
          </div>
          <div className={classes.column2} style={{ color:"#112B42"}}>
            <label htmlFor="" className={classes.label}>{formik.values.gstTreatment === GSTTreatment.Unregistered ? 'PAN' : 'GSTIN'} { formik.touched.gstin && formik.errors.gstin ? <span>{formik.errors.gstin}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.righttextfield}
              onFocus={(e: any) => e.target.select()}
              // disabled={editMode}
              { ...formik.getFieldProps('gstin') }
            />
            <br/>
            <label htmlFor="" className={classes.label}>Place of Supply { formik.touched.placeOfSupply && formik.errors.placeOfSupply ? <span>{formik.errors.placeOfSupply}</span> : null } </label><br/>
            <TextField
                InputProps={inputProps}
                className={classes.righttextfield}
                select
                SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              // disabled={editMode}
                { ...formik.getFieldProps('placeOfSupply') }
              >
                <MenuItem value={PlaceOfSupply.TN}>{PlaceOfSupply.TN}</MenuItem>
                <MenuItem value={PlaceOfSupply.KL}>{PlaceOfSupply.KL}</MenuItem>
                <MenuItem value={PlaceOfSupply.KN}>{PlaceOfSupply.KN}</MenuItem>
              </TextField>
          </div>
        </div>

        <div>
          <ItemList classes={classes} rows={rowListState} editMode={editMode} confirm={confirm} snackbar={snackbar} error={!rowListValid && rowListValid !== null} setState={setRowList} items={itemList}/>
        </div>
        <div className={classes.subtotal}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tablehead} style={{color:"#112B42"}}>Sub Total</TableCell>
                <TableCell className={classes.tablehead} style={{color:"#112B42"}} align="right">₹ {subTotal.toFixed(2)}</TableCell>
              </TableRow>
            </TableHead>
            {rowListState[0]&&rowListState[0].tax?<TableBody  style={{borderBottom:"25px solid rgba(0, 0, 0, 0)",}}>
              <TableRow>
                <TableCell className={classes.tablebody} style={{color:"#7F878A"}}>CGST [{(rowListState[0].tax/2).toFixed(2)}%]</TableCell>
                <TableCell className={classes.tablebody} style={{color:"#7F878A"}} align="right">₹ {cgst.toFixed(2)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tablebody} style={{color:"#7F878A"}}>SGST [{(rowListState[0].tax/2).toFixed(2)}%]</TableCell>
                <TableCell className={classes.tablebody} style={{color:"#7F878A"}} align="right">₹ {sgst.toFixed(2)}</TableCell>
              </TableRow>
            </TableBody>:null}
            <TableFooter style={{borderTop:"25px solid rgba(0, 0, 0, 0)",}}>
              <TableRow>
                <TableCell className={classes.tablefoot} style={{color:"#112B42"}}>Total</TableCell>
                <TableCell className={classes.tablefoot} style={{color:"#0079e4"}} align="right">₹ {total}</TableCell>
              </TableRow>
            </TableFooter>
          </Table><br/>

        </div>

      </div>
      <Loading loading={loading} text={patch ? 'Loading....': loadingText}/>
    </div> 
  );
}